import type {CssValue} from '../../constants'
import {deserializeFunction, serializeFunction} from './function'

const URL_FUNCTION_NAME: string = 'url'

export const serializeUrl = (url: CssValue): CssValue | undefined => {
    return serializeFunction({name: URL_FUNCTION_NAME, args: [url]})
}

export const deserializeUrl = (val: CssValue): CssValue | undefined => {
    const {name, args} = deserializeFunction(val) ?? {args: []}
    if (name !== URL_FUNCTION_NAME || args.length > 1) {
        return undefined
    }

    if (args?.length === 0) {
        return ''
    }

    return args[0]
}
